import Section from '../Section';

export default class DeliveryPartners extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.element = element;
    this.textWrapper = this.element.querySelector('.homepage-delivery-partners--text-wrapper');
    this.image = this.element.querySelector('.feature-row__image');

    this.resizeSection(); // allows tall text content to be contained within the image
  
    const self = this;
    window.addEventListener('resize', function() {
      self.resizeSection();
    });
  }

  resizeSection = () => {
    const sectionHeight = this.element.getBoundingClientRect().height;
    const textWrapperHeight = this.textWrapper.getBoundingClientRect().height;
    const offset = 100 // relates to 50px margin above and below text wrapper

    if (textWrapperHeight > sectionHeight - offset) {
      this.element.style.height = `${textWrapperHeight + offset}px`;
    }

    if (this.image && textWrapperHeight > sectionHeight - offset) {
      this.image.style.height = `${textWrapperHeight + offset}px`;
    }
  }
}
